import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from '@material-ui/core/styles'
import { Box, Container, Paper } from '@material-ui/core'
import Moment from 'react-moment'
import Cancel from '@material-ui/icons/Cancel'

import './ChatBotComponent.scss'
import { theme } from '../../classes/Themes'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import ChatBotHeaderComponent from './ChatBotHeaderComponent'
import ChatOpenAI from './ChatOpenAI'
import { CHAT_BOTS } from '../../constants/chat_bot'
import Profile from '../../classes/profile'

class ChatBotComponent extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    homepage: PropTypes.object,
    profile: Profile.PropTypes,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string
    }),
    classes: PropTypes.object.isRequired,
    threadId: PropTypes.string,
    messages: PropTypes.array,
    sendMessage: PropTypes.func,
    isFetching: PropTypes.bool,
    apiError: PropTypes.string,
    fetchThreadId: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = {
      screenWidth: window.innerWidth,
      selectedView: '',
      selectedViewLink: ''
    }
  }

  componentDidMount () {
    if (this.props.shortcut) {
      this.setSelectedView (this.props.shortcut.target)
    } else if (!this.props.shortcut && this.props.homepage?.details?.chat_bots) {
      let defaultChatBot = this.props.homepage?.details?.chat_bots?.filter(e => e.is_default === true) || []
      this.setState({
        selectedView: CHAT_BOTS.filter(e => e.botValue === defaultChatBot[0].name)[0].botName,
        selectedViewAssistantId: CHAT_BOTS.filter(e => e.botValue === defaultChatBot[0].name)[0].assistantId
      })
    }
  }

  setSelectedView = (view) => {
    let chatBot = CHAT_BOTS.filter(e => e.botValue === view)[0]
    this.setState({
      selectedView: view,
      selectedViewAssistantId: chatBot.assistantId
    })
  }

  _renderShortcut () {
    if (!this.props.shortcut || this.state.hideShortcutBanner) {
      return null
    }

    const expires = this.props.shortcut.expires_at
    const click = e => {
      e.preventDefault()
      this.setState({ hideShortcutBanner: true })
    }

    return (
      <div className='shortCutBanner'>
        <span>
          <span>This preview of <strong>Chat with Daisy</strong> will expire on&nbsp;</span>
          <Moment format='MM/DD/YYYY'>{expires}</Moment>
        </span>
        <span onClick={click}><Cancel /></span>
      </div>
    )
  }

  render () {
    return (
      <ThemeProvider theme={theme}>
        <div className="rightSide acquisationWrap">
          {this._renderShortcut()}
          <Container fluid="true" maxWidth="xl" className={this.props.classes.containerRootAA}>
            <ChatBotHeaderComponent
              isAdmin={this.props.isAdmin}
              homepage={this.props.homepage}
              profile={this.props.profile}
              shortcut={this.props.shortcut}
              selectedView={this.state.selectedView}
              selectedViewAssistantId={this.state.selectedViewAssistantId}
              setSelectedView={this.setSelectedView}
              fetchThreadId={this.props.fetchThreadId}
            />
            <Paper className="paperBase">
              <Box className="flex baseBox">
                <ChatOpenAI
                  profile={this.props.profile}
                  shortcut={this.props.shortcut}
                  messages={this.props.messages}
                  threadId={this.props.threadId}
                  selectedViewAssistantId={this.state.selectedViewAssistantId}
                  sendMessage={this.props.sendMessage}
                  isFetching={this.props.isFetching}
                  apiError={this.props.apiError}
                />
              </Box>
            </Paper>
          </Container>
        </div>
      </ThemeProvider>
    )
  }
}

export default withStyles(styles)(ChatBotComponent)
